import React from 'react';
import md5 from 'md5';
import _ from 'lodash';
import customNumber from '../../lib/customNumberFormatter';
import './Notification.scss';

class Notification extends React.Component {

    static getGravatar(data, size) {
        return (
            <div className="userImage">
                <img src={`//gravatar.com/avatar/${md5(data.registeredBy.email)}?size=${size}&d=blank`} className="avatar" alt={data.registeredBy.name} />
                <span className="notification-initials">
                    {Notification.getInitials(data.registeredBy.name)}
                </span>
            </div>
        );
    }

    static paintComponent(data) {
        var className = 'notification';

        if (data.useVideo) {
            className += ' video';
        } else {
            className += ' simple';
        }

        const orderRow = <h2>{customNumber.fixThousands(_.round(data.order.orderValue, 2))} {data.order.currency}</h2>; 

        return (
            <div className={className}>
                <div id="video"></div>

                {data.useVideo ? 
                <div id="notificationWrapper">
                    <div className="notificationContent">
                        {Notification.getGravatar(data, 150)}
                        <div style={{ margin: 'auto 0' }}>
                            <h1>{data.registeredBy.name} stängde affär med {data.client.name}!</h1>
                            {orderRow}
                        </div>
                    </div>
                </div>
                :
                <div id="notificationWrapper" className="notificationWrapper">
                    <div className="notificationContent">
                        {Notification.getGravatar(data, 700)}
                        <h1>{data.registeredBy.name} stängde affär med <br /> {data.client.name}!</h1>
                        {orderRow}
                    </div>
                </div>
                }
            </div>
        );
    }

    static getInitials(name) {
        const nameArr = name.split(' ');
        if (nameArr.length === 1) {
            return name[0];
        } else if (nameArr.length > 1) {
            return nameArr[0][0] + nameArr[nameArr.length-1][0]
        } else {
            return '';
        }
    }

    clearPlayQueue() {
        console.log('done playing:', this.state.playing.id);

        document.getElementById('notificationWrapper').firstChild.style.bottom = '-300px';

        // Delay clear to wait for animation, use same delay as .notificationContent

        setTimeout(() => {
            this.playQueue.shift();

            this.setState({
                playing: this.playQueue.length ? this.playQueue[0] : {},
            });
        }, 500)
    }

    playRegular(self) {
        var sound = document.createElement("AUDIO");
        sound.volume = 1;

        document.getElementById('notificationWrapper').style.display = 'table';

        setTimeout(() => {
            var i = setInterval(() => {
                if (sound.volume <= 0.1) {
                    clearInterval(i);

                    sound.pause();
                    sound.currentTime = 0;

                    self.clearPlayQueue();
                } else {
                    sound.volume -= 0.1;
                }
            }, 150);
        }, 18000);
    }

    playVideo(self) {
        var videoId = self.state.playing.videoId;

        var target = document.getElementById('video');
        var div = document.createElement('div');

        div.className = 'wistia_embed wistia_async_' + videoId;
        div.style.width = '100%';
        div.style.height = '100%';
        div.style.position = 'absolute';

        target.appendChild(div);

        window._wq.push({
            id: videoId,
            options: {
                endVideoBehavior: 'loop',
                volume: 1,
                autoPlay: false,
                controlsVisibleOnLoad: false,
                playButton: false,
            },
            onReady: (video) => {
                video.play();

                document.getElementById('notificationWrapper').style.display = 'table';

                setTimeout(() => {
                    var i = setInterval(() => {
                        if (video.volume() <= 0.1) {
                            clearInterval(i);

                            video.pause();

                            target.innerHTML = '';

                            var styles = document.getElementsByClassName('wistia_injected_style');

                            for (var j = 0; j < styles.length; j++) {
                                styles[j].remove();
                            }

                            self.clearPlayQueue();
                        } else {
                            video.volume(video.volume() - 0.1);
                        }
                    }, 150);
                }, 18000);

                video.bind('play', this.slideInNotification);
            },
        });
    }

    slideInNotification() {
        document.getElementById('notificationWrapper').firstChild.style.bottom = '0';
    }

    constructor(props) {
        super(props);

        this.state = {
            playing: {},
        };

        this.playQueue = [];
        this.playHistory = [];

        this.clearPlayQueue = this.clearPlayQueue.bind(this);
    }

    componentDidMount() {
        window._wq = window._wq || [];
    }

    componentWillReceiveProps(nextProps) {
        const data = nextProps.data;

        if (data && this.playHistory.indexOf(data.id) === -1) {
            this.playQueue.push(data);
            this.playHistory.push(data.id);

            if (_.isEmpty(this.state.playing)) {
                this.setState({ playing: this.playQueue[0] });
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !_.isEqual(this.state.playing, nextState.playing);
    }

    render() {
        if (!_.isEmpty(this.state.playing)) {
            console.log('now playing:', this.state.playing.id);

            return Notification.paintComponent(this.state.playing);
        }

        return null;
    }

    componentDidUpdate() {
        if (!_.isEmpty(this.state.playing)) {
            if (this.state.playing.useVideo) {
                this.playVideo(this);
            } else {
                this.playRegular(this);
            }
        } else {
            this.playHistory = [];
        }
    }

}

Notification.propTypes = {
    data: React.PropTypes.object,
};

export default Notification;



/** WEBPACK FOOTER **
 ** ./client/components/Notification/Notification.jsx
 **/